import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ResultImg } from './resultImg';
import { useSelectedResultInfoStore } from '@pascal/pascal-core';
import { AboutHash } from '../aboutHashComp/aboutHash';
import { FairnessFormGroup } from '@pascal/pascal-core/table-line/table-containers/fairnessFormGroup';

export const CheckHashPopup = observer(() => {
  const { selectedResultInfo } = useSelectedResultInfoStore();
  const scrollRef = useRef(null);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setToggle(false);
  }, []);

  useEffect(() => {
    if (toggle && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
  }, [toggle]);

  return (
    <div className='hash-code-wrp'>
      {selectedResultInfo.roundData && <ResultImg roundData={selectedResultInfo.roundData} />}
      <div className='hash-code-inp-wrp'>
        <div className='bc-forms-holder'>
          <FairnessFormGroup isShowCopyIcon isCheckResult aboutHashComp={AboutHash}  isShowAboutHash />
        </div>
      </div>
      {/*{toggle && <AboutHash t={t} scrollRef={scrollRef} />}*/}
    </div>
  );
});
